module.exports = "<div class=\"status-summary\"> <div class=\"status-summary__label\">{{'SYSTEMSTATUS.STATUSLABELV2' | translate}}</div> <div class=\"status-summary__summary\"> <span class=\"status-summary__dot {{$ctrl.indicator}}\"></span> <span class=\"status-summary__text\">{{$ctrl.statusText || 'SYSTEMSTATUS.DEFAULTSTATUS' | translate}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/statusPage/statusSummary.html
// module id = 1417
// module chunks = 28